import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import UsersList from "@/pages/UserManagement/UsersList";
import ApplicationsList from "@/pages/Application/ApplicationsList.vue";
import ApplicationDetails from "@/pages/Application/ApplicationDetails.vue";
import LogList from "@/pages/Logs/LogReports.vue";
import Login from "@/pages/Login.vue";
import UserDetails from "@/pages/UserManagement/UserDetails";
import SSOManagement from "@/pages/SSO/SSOManagement";
import AddNewClient from "@/pages/SSO/AddNewClient";
import Dashboard from "@/pages/Dashboard";
import PassThrough from "@/pages/PassThrough";
import ServerInfo from "@/pages/ServerInfo";
import Audit from "../pages/Audit";
import DashboardLoader from "@/pages/DashboardLoader";
import ServerConfiguration from "@/pages/ServerConfiguration/ServerConfiguration";
import AdminManagement from "@/pages/AdminManagement";
import HardwareOtpsList from "@/pages/HardwareOtps/HardwareOtpsList.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/dashboard-loader",
    name: "DashboardLoader",
    component: DashboardLoader,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard-loader",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        }
      },
      {
        path: "application-management",
        name: "Application Management",
        component: PassThrough,
        redirect: "application-management/applications",
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        },
        children: [
          {
            path: "applications",
            name: "Applications",
            component: ApplicationsList,
            meta: {
              requiresAuth: true,
              permissionGroups: ["application_admins", "viewer_admins"],
            }
          },
          {
            path: "applications/application-details",
            name: "Application Details",
            component: ApplicationDetails,
            meta: {
              requiresAuth: true,
              permissionGroups: ["application_admins", "viewer_admins"],
            }
          }
        ]
      },
      {
        path: "logs",
        name: "Authentication/Authorization Reports",
        component: LogList,
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        }
      },
      {
        path: "user-management",
        name: "User Management",
        component: PassThrough,
        redirect: "user-management/users",
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        },
        children: [
          {
            path: "users",
            name: "Users",
            component: UsersList,
            meta: {
              requiresAuth: true,
              permissionGroups: ["application_admins", "viewer_admins"],
            }
          },
          {
            path: "users/user-details",
            name: "User Details",
            component: UserDetails,
            meta: {
              requiresAuth: true,
              permissionGroups: ["application_admins", "viewer_admins"],
            }
          }
        ]
      },
      {
        path: "hardware-otps",
        name: "Hardware OTP Management",
        component: HardwareOtpsList,
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        },
      },
      {
        path: "sso-management",
        name: "SSO Management",
        component: SSOManagement,
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        }
      },
      {
        path: "sso-management/create",
        name: "Create New SSO Client",
        component: AddNewClient,
        meta: {
          requiresAuth: true,
          permissionGroups: ["application_admins", "viewer_admins"],
        }
      },
      {
        path: "server-info",
        name: "Server Info",
        component: ServerInfo,
        meta: {
          requiresAuth: true,
          permissionGroups: ["server_admins"]
        }
      },
      {
        path: "server-configuration",
        name: "Server Configuration",
        component: ServerConfiguration,
        meta: {
          requiresAuth: true,
          permissionGroups: ["server_admins"]
        }
      },
      {
        path: "audit",
        name: "Audit",
        component: Audit,
        meta: {
          requiresAuth: true,
          permissionGroups: ["server_admins"]
        }
      },
      {
        path: "admin-management",
        name: "Admin Management",
        component: AdminManagement,
        meta: {
          requiresAuth: true,
          permissionGroups: ["server_admins"]
        }
      }
    ]
  }
];

export default routes;
